import Image from "next/image"
import Link from "next/link"
import { Fragment, useEffect, useState } from "react"
import GameIconTag from "../ui/GameIconTag"
import guideImage from "../../assets/images/guide.webp"
import { cardImageLoader } from "../../utils/imageLoader"

const normalizeImageSrc = (value: unknown) => {
    if (typeof value !== "string") return ""
    const src = value.trim()
    if (!src || src === "null" || src === "undefined") return ""
    if (src.startsWith("http://") || src.startsWith("https://") || src.startsWith("/")) {
        return src
    }
    return `https://${src}`
}

const PopularNewsCard = (props: any) => {
    const [thumbnailSrc, setThumbnailSrc] = useState<any>(normalizeImageSrc(props.thumbnail) || guideImage)

    useEffect(() => {
        const nextSrc = normalizeImageSrc(props.thumbnail)
        setThumbnailSrc(nextSrc || guideImage)
    }, [props.thumbnail])

    return (
        <Fragment>
            {/* On Air: a hard-edged panel, the 16:9 artwork on top. The image and
                the title are separate links so the platform icons (links of
                their own) are never nested inside an <a>. */}
            <article className="group flex w-full flex-col overflow-hidden rounded-[4px] bg-theme-card">
                <Link
                    href={`/article/${props.id}`}
                    prefetch={false}
                    rel="noopener noreferrer"
                    aria-label={props.title || "Popular news"}
                    className="relative block aspect-[16/9] w-full overflow-hidden bg-theme-surface"
                >
                    <Image
                        src={thumbnailSrc}
                        loader={cardImageLoader}
                        alt={props.title || "Popular news"}
                        fill
                        sizes="(max-width: 640px) 100vw, 33vw"
                        className="object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]"
                        onError={() => {
                            setThumbnailSrc(guideImage)
                        }}
                    />
                </Link>
                <div className="flex flex-1 flex-col justify-between gap-3 px-4 pb-4 pt-3">
                    <Link href={`/article/${props.id}`} prefetch={false} rel="noopener noreferrer">
                        <h3 className="m-0 text-base font-semibold leading-snug text-theme-text line-clamp-3 transition-colors group-hover:text-signal dark:group-hover:text-[#8DB4FF] md:text-lg">
                            {props.title}
                        </h3>
                    </Link>
                    {props.textBlack || !props.tag?.[0]?.platform?.length ? null : (
                        <div className="flex items-center gap-2">
                            <GameIconTag tag={props.tag[0].platform} />
                        </div>
                    )}
                </div>
            </article>
        </Fragment>
    );
}

export default PopularNewsCard
